export type ComponentOption = {
  label: string;
  value: string;
};

export type HeaderComponent = {
  icon: string;
  key: string;
  label: string;
  position: number;
  containerType: HeaderComponentContainerType;
  modalSize?: ModalContainerSize;
  popupSizeOptions?: MinSizeOptions;
  floatingBoxSizeOptions?: MinSizeOptions;
  hideWithCss?: boolean; // NOTE: only for Floating box
};

export type HeaderComponentContainerType = 'modal' | 'popup' | 'floating';

export enum ModalContainerSize {
  S = 's',
  M = 'm',
  L = 'l',
}

export type MinSizeOptions = {
  minWidth: number;
  minHeight: number;
};

export type HeaderComponents = Record<string, HeaderComponent>;
